import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const createItemMutation = (params: {
	boardId: string;
	itemName: string;
	columnValues: string;
	createLabelsIfMissing?: boolean;
}) =>
	requestAndFormat(
		{
			defaultParams: {
				createLabelsIfMissing: false,
			},
			gql: gql`
				mutation CreateItem(
					$boardId: ID!,
					$itemName: String!
					$columnValues: JSON!,
					$createLabelsIfMissing: Boolean
				) {
					create_item (board_id: $boardId, item_name: $itemName, column_values: $columnValues, create_labels_if_missing: $createLabelsIfMissing) {
					id
					}
				}`,
			skipMondayFormatting: true,
			resultKey: "create_item",
			outType: {} as { id: string },
		},
		params,
	);
